import { getCarEBoxLocations } from './getCarEBoxLocations';
import { resetCarEBoxLocations } from './resetCarEBoxLocations';
import { setSelectedCarEBoxLocation } from './setSelectedCarEBoxLocation';
import { resetSelectedCarEBoxLocation } from './resetSelectedCarEBoxLocation';
import { getCarEBoxDashboardData } from './getCarEBoxDashboardData';
import { resetCarEBoxDashboardData } from './resetCarEBoxDashboardData';
import { getT4EObuDevices } from './getT4EObuDevices';
import { updateCarEBoxDashboardData } from './updateCarEBoxDashboardData';

export const carOperations = {
  getCarEBoxLocations,
  getCarEBoxDashboardData,
  resetCarEBoxLocations,
  resetCarEBoxDashboardData,
  updateCarEBoxDashboardData,

  setSelectedCarEBoxLocation,
  resetSelectedCarEBoxLocation,

  getT4EObuDevices,
};
